import { Route, Routes } from 'react-router-dom';
import { NotFound } from '../pages/errors/NotFound';
import { Login } from '../pages/Login';

export const LoginRoute = () => {
    return (
        <Routes>
            {/* User Routes */}
            <Route path="/" element={<Login />} />

            {/* 404 - Catch all unmatched routes */}
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};
